import type { ReactNode } from 'react'
import { useState } from 'react'
import type { QueryClient } from '@tanstack/react-query'
import { QueryClientProvider } from '@tanstack/react-query'
import type { i18n } from 'i18next'
import { I18nextProvider } from 'react-i18next'
import type { ApiClient } from '@dorixona/api'
import { createAppI18n } from './i18n'
import { createQueryClient } from './queryClient'
import { ApiProvider } from '../api/context'
import { api as appApi } from '../api/client'

export interface AppProvidersProps {
  children: ReactNode
  queryClient?: QueryClient
  i18nInstance?: i18n
  /** Клиент API для экранов; тест подставляет свой. */
  api?: ApiClient
}

export function AppProviders({ children, queryClient, i18nInstance, api }: AppProvidersProps) {
  // Клиент и i18n создаются один раз: новый QueryClient на каждый рендер
  // терял бы кэш — и профиль в сессии показывал бы старые данные.
  const [client] = useState(() => queryClient ?? createQueryClient())
  const [i18n] = useState(() => i18nInstance ?? createAppI18n())
  return (
    <QueryClientProvider client={client}>
      <I18nextProvider i18n={i18n}>
        <ApiProvider api={api ?? appApi}>{children}</ApiProvider>
      </I18nextProvider>
    </QueryClientProvider>
  )
}
